import { Link } from 'react-router-dom';

const anchors = [
  { href: '#propiedades', label: 'Propiedades' },
  { href: '#rentas', label: 'Rentas' },
  { href: '#inquilinos', label: 'Inquilinos' },
  { href: '#precios', label: 'Precios' },
];

export default function LandingNav() {
  return (
    <nav className="sticky top-0 z-40 backdrop-blur-md bg-[#F5F0E8]/80 border-b border-[#141414]/5">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="text-lg font-extrabold tracking-tight text-[#141414]">
          Takarah
        </Link>
        <div className="flex items-center gap-5 sm:gap-8 overflow-x-auto flex-1 min-w-0 mx-4 sm:mx-0 sm:flex-initial sm:justify-center [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {anchors.map((a) => (
            <a
              key={a.href}
              href={a.href}
              className="shrink-0 text-sm font-medium text-[#141414]/70 hover:text-[#141414] transition-colors"
            >
              {a.label}
            </a>
          ))}
        </div>
        <Link
          to="/login"
          className="text-sm font-semibold text-[#141414] border border-[#141414]/15 rounded-full px-4 py-1.5 hover:bg-[#141414] hover:text-white transition-colors"
        >
          Entrar
        </Link>
      </div>
    </nav>
  );
}
